<template>
  <div class="login_container">
    <div class="text_right">
      <!-- <div v-if="!istoWrite" class="timeout">
        报告锁定中，剩余：{{ minutes }}分{{
          seconds
        }}秒。请在限时内完成报告编写，否则解锁后其他人可编辑此报告
      </div> -->
      <div class="introduction">
        <!--startprint-->
        <!-- {{datahtml}} -->
        <div id='li_listers' class="introduction_lefts">
          <div class="datahtml" v-html="datahtml"></div>
        </div>
        <!--endprint-->
        <div class="li_box">
          <!-- <div v-if="istoWrite" class="li_list" @click="toWrite">
            <div>
              <img class="Vector" src="../../assets/Vector.png" alt="" />
            </div>
            <p>编写</p>
          </div> -->
          <div v-if="status != 2" class="li_list" @click="confirm">
            <div>
              <img class="Vector" src="../../assets/confirm.png" alt="" />
            </div>
            <p>确认</p>
          </div>
          <div v-if="status != 2" class="li_list" @click="cancelClickl">
            <div>
              <img class="Vector" src="../../assets/out.png" alt="" />
            </div>
            <p>回退</p>
          </div>
          <div class="li_list" @click="clicktudyInfo">
            <div>
              <img class="Vector" src="../../assets/影像.png" alt="" />
            </div>
            <p>影像</p>
          </div>
          <div class="li_list" @click="editinformation">
            <div>
              <img class="Vector" src="../../assets/modify.png" alt="" />
            </div>
            <p>修改</p>
          </div>
          <div @click='printpage' class="li_list">
            <div>
              <img class="Vector" src="../../assets/打印.png" alt="" />
            </div>
            <p>打印</p>
          </div>
          <div class="li_list" @click="heavyLoad">
            <div>
              <img class="Vector" src="../../assets/重载报告.png" alt="" />
            </div>
            <p>重载报告</p>
          </div>
          <div v-if="hasHistoryReport=='true'" class="li_list" @click="hisReport">
            <div>
              <img class="Vector" src="../../assets/申请单.png" alt="" />
            </div>
            <p>历史报告</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加弹框 -->
    <el-dialog
      top="15vh"
      title="设置"
      :visible.sync="dialogFormVisible"
      width="50%"
      :close-on-click-modal="false"
      class="addProp"
    >
      <!-- <el-form :model="form" :rules="rules" ref="form"> -->
      <div class="body_from">
        <div class="left_prop">
          <div class="header_prop">
            <div
              v-for="(item, index) in headerProp"
              :key="index"
              @click="switchProp(item.id)"
              :class="item.id == switchId ? 'header_propactive' : ''"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="setBox">
            <div>
              <el-form :model="form" :rules="rules" ref="form">
                <el-form-item
                  v-if="switchId == 1"
                  prop="hospitalId"
                  label="检查类别:"
                  :label-width="formLabelWidth"
                >
                  <el-select
                    @change="selectClick"
                    v-model="hospitalId"
                    placeholder="请选择检查类别"
                  >
                    <el-option
                      v-for="item in permissionOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-if="switchId == 0"
                  prop="hospitalId"
                  label="检查类别:"
                  :label-width="formLabelWidth"
                >
                  <el-select
                    @change="selectClickGY"
                    v-model="hospitalIds"
                    placeholder="请选择检查类别"
                  >
                    <el-option
                      v-for="item in GYlist"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <!-- <el-tree
              :data="tableDatas"
              :props="defaultProps"
              accordion
              highlight-current
              node-key="id"
              ref="vueTree"
              @node-contextmenu="rightClick"
              @node-click="nodeClicks"
            >
            </el-tree> -->
            <!-- 封装的el-tree -->
            <!-- <div style="position: relative"> -->
            <ScrollNum
              :treeList="tableDatas"
              :rightFlag="rightFlag"
              :defaultProps="defaultProps"
              :expandedKeys="expandedKeys"
              :nodeKey="nodeKey"
              @handleNodeClick="handleNodeClick"
              @handleRightClick="handleRightClick"
              @handleClickTreeMenu="handleClickTreeMenu"
              @updateTreeMenu="updateTreeMenu"
            ></ScrollNum>
            <!-- </div> -->
          </div>
        </div>
        <div class="setRight">
          <el-form
            :model="formEdit"
            label-position="top"
            :rules="rules"
            ref="formEdit"
          >
            <el-form-item
              prop="describeRight"
              label="描述"
              :label-width="formLabelWidth"
            >
              <el-input
                width="200"
                type="textarea"
                rows="4"
                placeholder="请输入描述"
                v-model="describeRight"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="tipsRight"
              label="诊断:"
              :label-width="formLabelWidth"
            >
              <el-input
                width="200"
                rows="4"
                type="textarea"
                placeholder="请输入诊断结果"
                v-model="tipsRight"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="button_box">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="postForm">确 定</el-button>
          </div>
        </div>
      </div>
      <!-- </el-form> -->
      <!-- <div slot="footer" class="dialog-footer">
        <div class="dev-type-main-left">
          <div v-show="showRightMenu">
            <ul id="menu" class="right-menu">
              <li class="menu-item" @click="addDevHandle">增加</li>
              <li class="menu-item" @click="editDevHandle">编辑</li>
              <li class="menu-item" @click="delDevHandle">删除</li>
            </ul>
          </div>
        </div>
      </div> -->
    </el-dialog>
    <!-- 修改弹框 -->
    <el-dialog
      top="15vh"
      :visible.sync="modify"
      width="20%"
      title="编辑节点名称"
      :close-on-click-modal="false"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item
          prop="value"
          label="编辑标题:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入标题名称"
            v-model="valuevalue"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modify = false">取 消</el-button>
        <el-button type="primary" @click="modifyClick">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 增加新节点弹窗 -->
    <el-dialog
      top="15vh"
      :visible.sync="addition"
      title="新增子节点"
      width="20%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-position="top" :rules="rules" ref="form">
        <el-form-item
          prop="username"
          label="节点名称:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入节点名称"
            v-model="nodename"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="hospitalId"
          label="节点类型:"
          :label-width="formLabelWidth"
        >
          <el-select
            @change="selectNode"
            v-model="nodemodel"
            placeholder="请选择节点类型"
            class="selectwidth"
          >
            <el-option
              v-for="item in nodeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modify = false">取 消</el-button>
        <el-button type="primary" @click="nodesClick">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 打印选择 -->
    <el-dialog
  title="打印选择"
  :visible.sync="dialogVisible"
  width="30%">
    <!-- <el-form-item
        prop="studyModality"
        label="检查类型:"
        :label-width="formLabelWidth"
      >
        <el-select
          v-model="studyModalitytitle"
          placeholder="请选择检查类型"
          class="search_input"
          clearable
        >
          <el-option
            v-for="item in departmentOption"
            :key="item.desc"
            :label="item.desc"
            :value="item.desc"
          ></el-option>
        </el-select>
      </el-form-item> -->
        <el-select v-model="studyModalitytitle" placeholder="请选择">
    <el-option
      v-for="item in departmentOption"
      :key="item.type"
      :label="item.desc"
      :value="item.type">
    </el-option>
  </el-select>

  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="routerrefs">确 定</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
// // import LangSelect from '@/components/LangSelect'
import ScrollNum from "../../components/trees.vue";
export default {
  name: "pdfconent",
  components: { ScrollNum },
  //   components: { SocialSign },
  data() {
    return {
      num: 1,
      patientId:'',
      hasHistoryReport:false,
      dialogVisible:false,
      status: "",
      idd: "",
      studyModality:'',
      studyModalitytitle:'',
      departmentOption:[],
      datahtml: "",
      expandedKeys: [],
      nodeids: "",
      nodeList: [
        {
          name: "类别节点",
          id: 1,
        },
        {
          name: "内容节点",
          id: 2,
        },
      ],
      nodename: "",
      nodemodel: "",
      addition: false,
      valuevalue: "",
      pidpid: "",
      idid: "",
      typetype: "",
      modelmodel: "",
      modify: false,
      ids: "",
      rightFlag: true, //是否显示右键菜单
      defaultProps: {
        // 定义展示的属性，treeList中是subs和mName,
        children: "subs",
        label: "mName",
      },
      nodeKey: "mid", // 树的唯一标志，mid,也是treeList的每一条数据的唯一标志
      syname: "",
      pids: 0,
      gyname: "",
      sytype: "",
      hospitalIds: [
        {
          name: "123",
          childrens: [
            {
              name: "456",
            },
          ],
        },
      ],
      hospitalId: "",
      treeList: [
        // 一般来源于后台
        {
          mid: "1",
          mName: "qqq",
          subs: [
            {
              mid: "2",
              mName: "aaaa",
            },
          ],
        },
      ],
      permissionOptions: [
        {
          name: "CT",
          id: 1,
        },
        {
          name: "放射",
          id: 2,
        },
        {
          name: "超声",
          id: 3,
        },
      ],
      GYlist: [
        {
          name: "CT",
          id: 1,
        },
        {
          name: "放射",
          id: 2,
        },
        {
          name: "超声",
          id: 3,
        },
      ],
      tableDatas: [
        {
          name: "123",
        },
      ],
      switchId: "0",
      headerProp: [
        {
          name: "公有",
          id: 0,
        },
        {
          name: "私有",
          id: 1,
        },
      ],
      disableds: true,
      form: {},
      describeRight: "",
      tipsRight: "",
      showRightMenu: false,
      dialogFormVisible: false,
      processList: "",
      times: "",
      userData: "",
      treeClickCount: 0,
      treeClickCounts: 0,
      formLabelWidth: "",
      description: "暂无信息",
      impression: "暂无信息",
      tableData: [],
      regisactive: "1",
      YinYangactive: "3",
      choiceactive: "3",
      formEdit: {
        abnormal: "",
        studyId: "",
        description: "",
        tips: "",
        templateId: "",
      },
      YinYang: [
        {
          name: "+阳性",
          id: 1,
        },
        {
          name: "-阴性",
          id: 0,
        },
      ],
      register: [
        {
          name: "1",
          id: 0,
        },
        {
          name: "2",
          id: 1,
        },
      ],
      defaultProps: {
        children: "childrens",
        label: "name",
      },
      choice: [
        {
          name: "3",
          id: 0,
        },
        {
          name: "4",
          id: 1,
        },
      ],
      rules: {},
      hour: 6, // 小时
      minutes: 30, // 分钟
      seconds: 0, // 秒
    };
  },
  created(e) {
    console.error('this.$router.currentRoute',this.$router.currentRoute);
    this.formEdit.studyId = this.$router.currentRoute.query.id;
    this.patientId = this.$router.currentRoute.query.patientId;
    this.hasHistoryReport = this.$router.currentRoute.query.hasHistoryReport;
    this.studyModality = this.$router.currentRoute.query.studyModality;
    // window.addEventListener('storage', this.afterQRScan)
    this.getMenuLinkageList();
    // this.getUser();
    // this.getDefautlId();
    this.getexportReportHtmlByStudyId();
    this.getIdd();
  },
  watch: {
    tableDatas(val, newval) {
      console.log(val);
      console.log(newval);
    },
  },
  mounted() {
    // this.timer();
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
  },
  methods: {
    hisReport(){
      let routeUrls = this.$router.resolve({
        path: "/lookimagehistory",
        query: {
          patientId: this.patientId,
        },
      });
      try {
        window.open(
          routeUrls.href,
          "_blank"
        );
      } catch (e) {
        //
      }
    },
    beforeunloadHandler(e) {
      window.aaa.close();
    },
    routerrefs(){
      let { href } = this.$router.resolve({
        path: "/historyRecordcopy",
        query: {
          id: this.formEdit.studyId,
          studyModalitytitle:this.studyModalitytitle,
        },
      });
      window.open(href, "_blank");
      this.dialogVisible = false
    },
     printpage() {
      if(this.studyModality == 'US'){
        this.dialogVisible = true;
        depot
        .get({
          url: "/v1/report/listPrintTypes",
          params: {
            token: sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.departmentOption = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
      }else {
        let { href } = this.$router.resolve({
        path: "/historyRecord",
        query: {
          id: this.formEdit.studyId,
        },
      });
      window.open(href, "_blank");
      }
       console.log(123)
      // let newstr = document.getElementById("li_listers").innerHTML;
      // console.log(newstr);
      // document.body.innerHTML = newstr;
      // window.print();
      // window.location.reload();
      // return false;
    },
    getIdd() {
      depot
        .get({
          url: "/v1/report/getReport",
          params: {
            token: sessionStorage.getItem("token"),
            studyId: this.formEdit.studyId,
          },
        })
        .then((res) => {
          console.log(res);
          this.idd = res.data.id;
          this.status = res.data.status;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    confirm() {
      this.$confirm('您确定要审核报告吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           depot
        .post({
          url: "/v1/report/postReport",
          data: {
            id: this.idd,
          },
        })
        .then((res) => {
          console.log(res);
          if (res.success == true) {
            this.$message({
              message: res.data,
              type: "success",
            });
             this.$router.push({
                  path: "/study/history",
                });
            return;
          }
          this.$message({
            message: res.msg,
            type: "error",
          });
        })
        .catch((err) => {
          console.log(err);
        });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
    },
    cancelClickl() {
      this.$confirm('您确认回退报告吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          depot
        .post({
          url: "/v1/report/examReport",
          data: {
            id: this.idd,
          },
        })
        .then((res) => {
          console.log(res);
          if (res.success == true) {
            this.$message({
              message: res.data,
              type: "success",
            });
             this.$router.push({
                  path: "/study/history",
                   query: {
                    username: this.$router.currentRoute.query.username,
                    studyNo: this.$router.currentRoute.query.studyNo,
                    modality: this.$router.currentRoute.query.modality,
                    partExamined: this.$router.currentRoute.query.partExamined,
                    hospitalId: this.$router.currentRoute.query.status,
                    hospitalIdyiyuan: this.$router.currentRoute.query.hospitalId,
                    day: this.$router.currentRoute.query.day,
                    startTime:this.$router.currentRoute.query.startTime,
                    endTime:this.$router.currentRoute.query.endTime,
                    currentPage:this.$router.currentRoute.query.page,
                   }
                });
            return;
          }
          this.$message({
            message: res.msg,
            type: "error",
          });
        })
        .catch((err) => {
          console.log(err);
        });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
    },
    editinformation() {
      this.$router.push({
        path: "/editimagetext",
        query: {
          id: this.formEdit.studyId,
          patientId: this.patientId,
          hasHistoryReport:this.hasHistoryReport,
          edit: 1,
        },
      });
    },
    getexportReportHtmlByStudyId() {
      depot
        .get({
          url: "/v1/report/exportReportHtmlByStudyId",
          params: {
            token: sessionStorage.getItem("token"),
            studyId: this.formEdit.studyId,
          },
        })
        .then((res) => {
          console.log(res);
          this.datahtml = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clicktudyInfo() {
      // let { href } = this.$router.resolve({
      //   path: "/report",
      //   query: {
      //     userId: this.formEdit.studyId,
      //   },
      // });
      // window.open(href, "_blank");
        let { href } = this.$router.resolve({
        path: "/report",
        query: {
          userId: this.formEdit.studyId,
        },
      });
      var width = 10000;
      var Height = 10000;
      var left = 2200;
      console.log('window.screenX',window.screenX);
      left += window.screenX;
      try{
        if(window.aaa != null){
           window.aaa.close();
        }
             window.aaa = window.open(href, '', 'width=' + width + ', height=' + Height + ', top=0, left=' + left + ', screenX=0,screenY=0,toolbar=no,status=no,location=no,directories=no,menubar=no,titlebar=no,fullscreen=yes,channelmode=yes,copyhistory=no');
            //  if(this.num === 1){
                
            //      this.num = 2;
            //  }else{
            //      this.num = 1;
            //  }
            //  window.aaa.close();
         }catch (e) {
             //
         }
    },
    nodesClick() {
      depot
        .post({
          url: "/v1/diagTemplate/private/save",
          data: {
            name: this.nodename,
            model: this.nodeids,
            type: this.typetype,
            pid: this.idid,
          },
        })
        .then((res) => {
          console.log(res);
          this.addition = false;
          this.nodename = "";
          this.nodeid = "";
          this.switchProp(1);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.data,
            });
            return;
          }
          this.$message({
            type: "error",
            message: res.msg,
          });
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: err.data,
          });
        });
    },
    selectNode(id) {
      console.log(id);
      this.nodeids = id;
    },
    modifyClick() {
      depot
        .post({
          url: "/v1/diagTemplate/private/update",
          data: {
            id: this.idid,
            model: this.modelmodel,
            type: this.typetype,
            name: this.valuevalue,
            pid: this.pidpid,
          },
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            // this.dialogFormVisible = false;
            this.modify = false;
            this.switchProp(1);
            this.$message({
              type: "success",
              message: res.data,
            });
            return;
          }
          this.$message({
            type: "error",
            message: res.msg,
          });
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: err.data,
          });
        });
    },
    getNode(data) {
      console.log(data);
    },
    updateTreeMenu(val) {
      console.log(val);
      this.rightFlag = val;
    },
    handleNodeClick(e) {
      console.log(e);
      this.impression = e.impression;
      this.pids = e.pid;
      this.ids = e.id;
      //记录点击次数
      this.treeClickCounts++;
      //单次点击次数超过2次不作处理,直接返回,也可以拓展成多击事件
      if (this.treeClickCounts >= 2) {
        return;
      }
      //计时器,计算300毫秒为单位,可自行修改
      this.timer = window.setTimeout(() => {
        if (this.treeClickCounts == 1) {
          //把次数归零
          this.treeClickCounts = 0;
          //单击事件处理
          console.log("单击事件,可在此处理对应逻辑");
          this.syname = e.name;
          // this.describeRight = e.impression;
          if (e.model == 2) {
            if (e.impression != undefined) {
              this.describeRight = e.impression;
            }
            if (e.description != undefined) {
              this.tipsRight = e.description;
            }
          }
        }
      }, 300);
    },
    handleRightClick(obj) {
      if (this.switchId == 1) {
        this.rightFlag = true; //显示右键菜单
      }
      console.log("鼠标右键单击了该节点", obj);
      this.valuevalue = obj.name;
      this.pidpid = obj.pid;
      this.typetype = obj.type;
      this.idid = obj.id;
      this.modelmodel = obj.model;
    },
    handleClickTreeMenu(name) {
      if (name == "编辑标题") {
        this.modify = true;
      } else if (name == "删除节点") {
        this.$confirm("您将删除选中的节点, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            depot
              .post({
                url: "/v1/diagTemplate/private/delete",
                data: {
                  id: this.idid,
                },
              })
              .then((res) => {
                if (res.code == 200) {
                  this.switchProp(1);
                  this.$message({
                    type: "success",
                    message: res.msg,
                  });
                  return;
                }
                console.log(res);
                this.$message({
                  type: "error",
                  message: res.data,
                });
              })
              .catch((err) => {
                console.log(err);
                this.$message({
                  type: "error",
                  message: err.data,
                });
              });
          })
          .catch(() => {});
      } else if (name == "添加子节点") {
        this.addition = true;
      }
      this.rightFlag = false;
    },
    selectClick(e) {
      this.sytype = e;
      console.log(e);
      depot
        .get({
          url: "/v1/diagTemplate/private/list",
          params: {
            token: sessionStorage.getItem("token"),
            type: e,
          },
        })
        .then((res) => {
          console.log(res);
          this.tableDatas = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectClickGY(e) {
      console.log(e);
      depot
        .get({
          url: "/v1/diagTemplate/public/list",
          params: {
            token: sessionStorage.getItem("token"),
            type: e,
          },
        })
        .then((res) => {
          console.log(res);
          this.tableDatas = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    switchProp(id) {
      console.log(id);
      this.switchId = id;
      if (id == 1) {
        depot
          .get({
            url: "/v1/diagTemplate/private/list",
            params: {
              token: sessionStorage.getItem("token"),
              type: 1,
            },
          })
          .then((res) => {
            console.log(res);
            this.tableDatas = res.data;
            console.log(this.tableDatas);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    toWrite() {
      depot
        .get({
          url: "/v1/report/tryLockReport",
          params: {
            token: sessionStorage.getItem("token"),
            studyId: this.formEdit.studyId,
          },
        })
        .then((res) => {
          if (res.success == true) {
            this.disableds = false;
            this.istoWrite = false;
            this.timer();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    heavyLoad() {
      location.reload();
    },
    postForm() {
      if (this.switchId == 0) {
        //修改公有
        depot
          .post({
            url: "/v1/diagTemplate/public/update",
            data: {
              id: this.ids,
              impression: this.describeRight,
              description: this.tipsRight,
              model: 2,
              type: this.sytype,
              name: this.gyname,
              pid: this.pids,
            },
          })
          .then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: res.msg,
              });
              return;
            }
            this.$message({
              type: "error",
              message: res.data,
            });
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              type: "error",
              message: err.data,
            });
          });
      } else {
        //修改私有
        depot
          .post({
            url: "/v1/diagTemplate/private/update",
            data: {
              id: this.ids,
              impression: this.describeRight,
              description: this.tipsRight,
              model: 2,
              type: this.sytype,
              name: this.syname,
              pid: this.pids,
            },
          })
          .then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: res.data,
              });
              return;
            }
            this.$message({
              type: "error",
              message: res.msg,
            });
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              type: "error",
              message: err.data,
            });
          });
      }
    },
    nodeClick(data) {
      console.log("Node Click", data.id, data, data.name);
    },
    nodeClicks(data) {
      console.log("Node Click", data.id, data, data.name);
    },
    addDevHandle() {},
    editDevHandle() {},
    // 删除操作
    delDevHandle() {},
    rightClick(event, data, node, obj) {
      this.showRightMenu = false; // 先把模态框关死，目的是：第二次或者第n次右键鼠标的时候 它默认的是true
      this.showRightMenu = true;
      let menu = document.querySelector("#menu");
      menu.style.left = event.clientX - 220 + "px";
      menu.style.top = event.clientY - 5 + "px";
      // 给整个document添加监听鼠标事件，点击任何位置执行closeRightMenu方法，及时将菜单关闭
      document.addEventListener("click", this.closeRightMenu);
      console.log("event", event, event.clientX, event.clientY);
      console.log("data", data);
      console.log(node);
    },
    closeRightMenu() {
      this.showRightMenu = false;
      // 及时关掉鼠标监听事件
      document.removeEventListener("click", this.closeRightMenu);
    },
    Submitinformation() {
      this.$refs["formEdit"].validate((valid) => {
        if (valid) {
          depot
            .post({
              url: "/v1/report/saveReport",
              data: this.formEdit,
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.$message({
                  message: res.data,
                  type: "success",
                });
                this.$router.push({
                  path: "/study/history",
                });
                return;
              }
              this.$message({
                message: res.msg,
                type: "error",
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    clicksetUp() {
      this.dialogFormVisible = true;
    },
    timer() {
      let _this = this;
      // 创建一个定时器
      let time = window.setInterval(function () {
        // 如果秒数为0 && 分钟数还没有为0
        if (_this.seconds === 0 && _this.minutes !== 0) {
          console.log(1);
          // 秒数变为59  分钟数--
          _this.seconds = 59;
          _this.minutes -= 1;
          // 都为0的时候 清除定时器
        } else if (
          _this.minutes === 0 &&
          _this.seconds === 0 &&
          _this.hour === 0
        ) {
          console.log(2);
          window.clearInterval(time);
          // 分钟数和秒数同时为0  小时数--  分钟数和秒数都变为59
        } else if (_this.minutes === 0 && _this.seconds === 0) {
          console.log(3);
          window.clearTimeout(time);
        } else {
          _this.seconds -= 1;
        }
      }, 1000);
    },
    time(time = +new Date()) {
      var date = new Date(time + 8 * 3600 * 1000);
      return date.toJSON().substr(0, 19).replace("T", " ").replace(/-/g, "-");
    },
    nodeClick(e) {
      console.log(e);
      this.impression = e.impression;
      //记录点击次数
      this.treeClickCount++;
      //单次点击次数超过2次不作处理,直接返回,也可以拓展成多击事件
      if (this.treeClickCount >= 2) {
        return;
      }
      //计时器,计算300毫秒为单位,可自行修改
      this.timer = window.setTimeout(() => {
        if (this.treeClickCount == 1) {
          //把次数归零
          this.treeClickCount = 0;
          //单击事件处理
          console.log("单击事件,可在此处理对应逻辑");
          this.gyname = e.name;
        } else if (this.treeClickCount > 1) {
          //把次数归零
          this.treeClickCount = 0;
          //双击事件
          console.log("双击事件,可在此处理对应逻辑");
          console.log(this.choiceactive);
          if (this.choiceactive == 3) {
            if (e.impression != undefined) {
              this.formEdit.tips += e.impression;
            }
            if (e.description != undefined) {
              this.formEdit.description += e.description;
            }
          } else {
            if (e.impression != undefined) {
              this.formEdit.tips = e.impression;
            }
            if (e.description != undefined) {
              this.formEdit.description = e.description;
            }
          }
        }
      }, 300);
    },
    nodeClicks(e) {
      console.log(e);
      this.impression = e.impression;
      //记录点击次数
      this.treeClickCounts++;
      //单次点击次数超过2次不作处理,直接返回,也可以拓展成多击事件
      if (this.treeClickCounts >= 2) {
        return;
      }
      //计时器,计算300毫秒为单位,可自行修改
      this.timer = window.setTimeout(() => {
        if (this.treeClickCounts == 1) {
          //把次数归零
          this.treeClickCounts = 0;
          //单击事件处理
          console.log("单击事件,可在此处理对应逻辑");
          this.syname = e.name;
          this.describeRight = e.impression;
          if (e.model == 2) {
            if (e.impression != undefined) {
              this.describeRight = e.impression;
            }
            if (e.description != undefined) {
              this.tipsRight = e.description;
            }
          }
        }
      }, 300);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    getMenuLinkageList(value) {
      // console.log(value);
      depot
        .get({
          url: "/v1/diagTemplate/public/list",
          params: {
            token: sessionStorage.getItem("token"),
            type: 1,
          },
        })
        .then((res) => {
          console.log(res);
          this.tableData = res.data;
          console.log(this.tableData);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    registerclick(name, id) {
      this.regisactive = name;
      this.registerId = id;
      console.log(this.registerId);
      if (this.registerId == 1) {
        depot
          .get({
            url: "/v1/diagTemplate/private/list",
            params: {
              token: sessionStorage.getItem("token"),
              type: 1,
            },
          })
          .then((res) => {
            console.log(res);
            this.tableData = res.data;
            console.log(this.tableData);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.getMenuLinkageList();
      }
    },
    YinYangclick(name, id) {
      if (this.istoWrite == false) {
        this.YinYangactive = id;
        this.formEdit.abnormal = id;
        console.log(this.formEdit.abnormal);
      }
    },
    choiceclick(name, id) {
      this.choiceactive = name;
      this.choiceId = id;
      console.log(this.choiceId);
    },
  },
  beforeRouteLeave(to,from,next){
   to.meta.keepAlive = false
   next(0)
 },
  destroyed() {
    // alert(123);
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    //  window.aaa.close();
  },
  
};
</script>

<style lang="scss">
* {
    -webkit-print-color-adjust: exact !important;   /* Chrome, Safari */
    color-adjust: exact !important;                 /*Firefox*/
}
.selectwidth {
  width: 100%;
}
.button_box {
  padding-bottom: 20px;
  padding-top: 20px;
  display: flex;
  justify-content: flex-end;
}
.addProp .el-dialog .el-dialog__body {
  padding: 0px !important;
}
.addProp .el-dialog .el-dialog__header {
  background: #f8f8f8 !important;
  border-bottom: 1px solid #eee !important;
}
.header_prop div:first-child {
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  // border: 2px solid #fff;
  padding-bottom: 5px;
  box-sizing: border-box;
}
.header_prop div:last-child {
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  // border: 2px solid #fff;
  padding-bottom: 5px;
  box-sizing: border-box;
}
.header_propactive {
  border-bottom: 2px solid #009b43 !important;
  padding-bottom: 3px !important;
}
.header_prop {
  display: flex;
  margin-bottom: 20px;
}
.left_prop {
  display: flex;
  flex-direction: column;
  // border-right: 1px solid #7e7e7e;
  margin-left: 20px;
  margin-top: 10px;
}
.setRight {
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  background: #f2f2f2;
}
.body_from {
  display: flex;
}
.setBox {
  height: 500px;
  width: 300px;
  // border-right: 1px solid #7e7e7e;
  overflow-y: scroll;
  overflow-x: scroll;
}
.dev-type-main-left {
  overflow: auto;
  padding: 10px;
  .right-menu {
    z-index: 1;
    position: absolute;
    height: 100px;
    width: 100px;
    position: absolute;
    border-radius: 5px;
    border: 1px solid #ccc;
    background-color: white;
    .menu-item {
      //display: block;
      line-height: 20px;
      text-align: left;
      margin-top: 10px;
      font-size: 14px;
      color: #606266;
    }
    li:hover {
      background-color: #edf6ff;
      color: #606266;
    }
  }
}
.timetime {
  color: #7e7e7e;
}
.process_box {
  margin-top: 23px;
  height: 200px;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.circular {
  position: relative;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #c4c4c4;
  margin-right: 15px;
}
.process_box .process:first-child .circular {
  background: #009b43;
}
.process_box .process:last-child .circular::after {
  display: none;
}
.circular::after {
  position: absolute;
  content: "";
  width: 1px;
  left: 6px;
  // margin-left: -6px;
  top: 12px;
  height: 55px;
  background: #f0f0f0;
}
.process {
  display: flex;
  align-items: baseline;
  margin-bottom: 15px;
}
.button_technological {
  margin-top: 18px;
}
.technological {
  width: 330px;
  background: #fff;
}
.Vector {
  width: 37px;
  height: 37px;
  object-fit: contain;
}
.li_box .li_list:last-child {
  border-bottom: 0px;
  padding-bottom: 0px;
}
.li_box {
  width: 48px;
  background: #fff;
  padding: 9px 10px 9px 10px;
  box-sizing: border-box;
  height: max-content;
}
.li_list p {
  color: #5f5f5f;
  text-align: center;
}
.li_list {
  cursor: pointer;
  padding-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  margin-bottom: 15px;
}
.Inspection {
  margin-top: 20px;
  margin-bottom: 20px;
}
.Inspection span:first-child {
  margin-right: 8px;
  color: #5f5f5f;
}
.usercontent span {
  margin-right: 40px;
}
.header_intro {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.introduction_lefts {
  width: 100%;
  margin-right: 27px;
  background: #fff;
  box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
}
.datahtml {
  padding-top: 60px;
  padding-bottom: 60px;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.introduction {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.text_right {
  width: 64%;
}
.timeout {
  width: 100%;
  height: 42px;
  background: rgba(237, 111, 0, 0.08);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  box-sizing: border-box;
}
.buttomPreview {
  margin-top: 20px !important;
}
.bodyPreview div:first-child {
  color: #797c7a;
}
.bodyPreview div:last-child {
  margin-top: 5px;
}
.bodyPreview {
  margin-top: 10px;
  padding-left: 10px;
  box-sizing: border-box;
}
.first_preview {
  padding: 10px 0px;
  background: rgba(0, 155, 67, 0.05);
  padding-left: 15px;
  box-sizing: border-box;
}
.previewBox {
  margin-top: 20px;
}
.bodyBox_child {
  border: 1px solid #f0f0f0;
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.bodyBox {
  padding: 6px 9px;
  margin-top: 20px;
  box-sizing: border-box;
  width: 100%;
  height: 350px;
  overflow-y: scroll;
  border-radius: 5px;
}
.setUp {
  width: 16%;
  height: 40px;
  color: black;
  background: rgba(0, 155, 67, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: 15px;
  cursor: pointer;
}
.headerBox {
  display: flex;
  padding: 6px 9px;
  box-sizing: border-box;
  width: 100%;
}


.text_left {
  box-sizing: border-box;
}
.box_regis {
  display: flex;
  margin-right: 15px;
  width: 32%;
}
.yinyang_regis span:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.yinyang_regis span:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.yinyang_regis {
  display: flex;
}
.register {
  cursor: pointer;
  width: 50%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  // background: rgba(0, 155, 67, 0.05);
  font-size: 14px;
  opacity: 0.8;
}
.YinYang {
  cursor: pointer;
  width: 86px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  border: 1px solid #cecece;
  font-size: 14px;
  opacity: 0.8;
}
.registeractive {
  cursor: pointer;
  color: #fff;
  background: #009b43;
}
.YinYangactive {
  background: #ed6f00;
  cursor: pointer;
  color: #fff;
  border: 1px solid #ed6f00;
}
.text_left {
  width: 260px;
  height: 90vh;
  background: #fff;
}
.login_container {
  display: flex;
  // height: 100%;
  margin-top: 10px;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/lookimagetext/index.vue